<template>
  <layout>
    <page-header :actions="actions" :header="$t('partners.title')" />
    <div class="content">
      <admin-table ref="table" v-bind="tableProps">
        <template slot="name" slot-scope="{ item }">
          <div class="media">
            <div class="media-left mr-2">
              <div class="h-10 w-10">
                <img
                  v-if="item.avatar && item.avatar.url"
                  :src="thumb(item.avatar, 60, 60, true)"
                  class="rounded-full max-w-full"
                  alt=""
                />
                <avatar
                  v-else
                  :username="item.name"
                  :size="40"
                  :custom-style="{ maxWidth: '100%', maxHeight: '100%' }"
                  :rounded="true"
                />
              </div>
            </div>
            <div class="media-body">
              {{ item.name }}
            </div>
          </div>
        </template>
      </admin-table>
    </div>
  </layout>
</template>

<script>
import { AdminTable } from 'stylemix-vue-admin'
import { create } from 'vue-modal-dialogs'
import Avatar from 'vue-avatar'
import UsersApi from '../users/UsersApi'
import AddPartner from './AddPartner'

const resourceBase = 'users'

const invoicingRoute = ({ id }) => {
  return {
    name: 'partners.commissions',
    params: { partner_id: id },
  }
}

export default {
  name: 'PartnersIndex',

  components: {
    AdminTable,
    Avatar,
  },

  data() {
    return {
      actions: [
        {
          id: 'create',
          text: this.$t('partners.add_new'),
          icon: 'icon-plus-circle2',
          onClick: () => {
            this.addPartner().then(result => {
              if (!result) return
              this.$refs.table.refresh()
            })
          },
        },
      ],

      tableProps: {
        base: resourceBase,
        apiBuilder() {
          return new UsersApi().setParameters({
            'where[partner]': true,
            context: 'list',
          })
        },
        columns: [
          {
            key: 'id',
            label: 'ID',
            sortable: true,
          },
          {
            key: 'name',
            label: this.$t('partners.name'),
          },
          {
            key: 'email',
            label: 'Email',
            sortable: true,
          },
          {
            key: 'partner_bookings_count',
            label: this.$t('partners.partner_bookings_count'),
            sortable: true,
            formatter: value => (value ? value : 0),
          },
          {
            key: 'partner_commission',
            label: this.$t('partners.commission'),
            sortable: true,
            formatter: value => (value ? `${value}%` : null),
          },
        ],
        searchFields: [
          {
            component: 'text-field',
            type: 'search',
            attribute: 'query',
            placeholder: this.$t('users.search'),
          },
        ],

        rowActions: item => {
          return [
            {
              label: this.$t('partners.invoicing'),
              variant: 'light',
              handler: () => {
                this.$router.push(invoicingRoute(item))
              },
            },
            'edit',
          ]
        },

        bulkActions: () => {
          return []
        },
      },
    }
  },

  created() {
    this.addPartner = create(AddPartner)
  },
}
</script>
